import React from "react";
import styled from "styled-components";

const ContentHeader = styled.h5`
  font-family: "Syne";
  color: #514e4e;
  font-weight: 700;
  font-size: 18px;

  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

const ContentParagraph = styled.p`
  font-size: 16px;
  line-height: 24px;
  text-align: justify;
  color: #514e4e;
`;

const ContentNumWrapper = styled.div`
  width: 50px;
  height: 50px;
  background-color: #ededed;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentNum = styled.span`
  font-family: "Syne";
  font-weight: 700;
  font-size: 32px;
  line-height: 37px;
  color: #af3c2c;
`;

const ServiceCard = ({ content }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <ContentHeader>
        <ContentNumWrapper>
          <ContentNum>{content?.id}</ContentNum>
        </ContentNumWrapper>
        {content?.title}
      </ContentHeader>
      <ContentParagraph>{content?.description}</ContentParagraph>
    </div>
  );
};

export default ServiceCard;
